import { createSelector } from "reselect";
import * as api from "@/api/division-manager";

// constants

const prefix = "admin/division/details";

const FETCH_START = `${prefix}/FETCH_START`;
const FETCH_FAIL = `${prefix}/FETCH_FAIL`;
const FETCH_SUCCESS = `${prefix}/FETCH_SUCCESS`;

// actions

const fetchStart = () => ({ type: FETCH_START });
const fetchSuccess = (data) => ({ type: FETCH_SUCCESS, payload: data });
const fetchFail = (err) => ({ type: FETCH_FAIL, error: true, payload: err });

export function fetchDivisionDetails(id) {
  return async (dispatch) => {
    dispatch(fetchStart());

    try {
      const data = await api.fetchRecord(id);
      dispatch(fetchSuccess(data));
    } catch (err) {
      dispatch(fetchFail(err));
    }
  };
}

// selectors
const baseSelector = (state) => state.divisionManager.divisionDetails;
export const getDivisionDetails = createSelector(baseSelector, (state) => state.record);
export const getDivisionDetailsIsFetching = createSelector(baseSelector, (state) => state.isFetching);
export const getDivisionDetailsError = createSelector(baseSelector, (state) => state.error);
export const getDivisionDetailsHasError = createSelector(baseSelector, (state) => !!state.error);

// state

const initialState = {
  record: null,
  error: false,
  isFetching: false,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_START:
      return {
        ...state,
        record: null,
        isFetching: true,
      };

    case FETCH_SUCCESS:
      return {
        ...state,
        record: action.payload,
        isFetching: false,
        error: null,
      };

    case FETCH_FAIL:
      return {
        ...state,
        isFetching: false,
        error: action.payload,
      };

    default:
      return state;
  }
}
